// pages/monitor/panels/peak/PeakAlarm.js —— 削峰填谷 · 故障告警（基准：多类型复用页）
// 今日告警 / 历史告警 + 设备类型·告警等级·状态筛选 + 原文标题列头 AI 翻译。详见 panels/AlarmView.js。
import React from 'react';
import AlarmView from '../AlarmView';

const PeakAlarm = () => <AlarmView />;

export default PeakAlarm;